/**
 * Builds before US-2134 wrote the whole query cache to this IndexedDB database in plaintext and
 * never removed it. The cache is now in memory only; this deletes what an older build left behind.
 *
 * Fire and forget: an open tab of an older build holds a connection, which leaves the delete
 * `blocked` until that tab closes, so nothing may wait for it.
 */
export const LEGACY_QUERY_STORE = 'tk-tanstack-query-store';

export function deleteLegacyQueryStore(): void {
    try {
        if (typeof indexedDB === 'undefined') {
            return;
        }
        indexedDB.deleteDatabase(LEGACY_QUERY_STORE);
    } catch {
        // storage unavailable (private mode, blocked site data): there is nothing to delete
    }
}
